import { l as matchesBreakpoint, u as scrollAnimationsDisabled } from "@theme/utils";
import { t as gsapWithCSS } from "@theme/gsap";
import { n as ensureSplitText } from "@theme/gsap-utils";
//#region frontend/islands/in-view-text.js
var PRESETS = {
	"fade-up": {
		from: {
			opacity: 0,
			y: 10
		},
		to: {
			opacity: 1,
			y: 0
		}
	},
	"fade-down": {
		from: {
			opacity: 0,
			y: -10
		},
		to: {
			opacity: 1,
			y: 0
		}
	},
	"fade-right": {
		from: {
			opacity: 0,
			x: -10
		},
		to: {
			opacity: 1,
			x: 0
		}
	}
};
function replaceHyphens(el) {
	const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
	let node;
	while (node = walker.nextNode()) if (node.textContent.includes("-")) node.textContent = node.textContent.replaceAll("-", "‑");
}
function normalizeSpaces(el) {
	const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
	let node;
	while (node = walker.nextNode()) if (node.textContent.includes(" ")) node.textContent = node.textContent.replaceAll(" ", " ");
}
var InViewText = class extends window.HTMLElement {
	async connectedCallback() {
		await document.fonts.ready;
		if (!this.isConnected) return;
		const animation = this.dataset.animation;
		const type = this.dataset.type;
		const target = this.querySelector(":scope > :first-child");
		if (!target || !animation || !PRESETS[animation]) return;
		if (!matchesBreakpoint(this.dataset.breakpoint)) return;
		if (scrollAnimationsDisabled() || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
			gsapWithCSS.set(target, {
				opacity: 1,
				visibility: "visible"
			});
			return;
		}
		if (this._played || this.closest(".swiper-slide-duplicate")) {
			gsapWithCSS.set(target, {
				opacity: 1,
				visibility: "visible"
			});
			return;
		}
		const preset = PRESETS[animation];
		this._viewObserver = new IntersectionObserver(async (entries) => {
			if (!entries[0].isIntersecting) return;
			this._viewObserver.disconnect();
			this._viewObserver = null;
			const SplitText = await ensureSplitText();
			this._initAnim(target, preset, type, SplitText);
		}, { rootMargin: "300px 0px" });
		this._viewObserver.observe(target);
	}
	_initAnim(target, preset, type, SplitText) {
		if (window.matchMedia("(max-width: 767px)").matches) {
			gsapWithCSS.set(target, {
				...preset.from,
				visibility: "visible"
			});
			this._animObserver = new IntersectionObserver((entries) => {
				if (!entries[0].isIntersecting) return;
				this._animObserver.disconnect();
				this._animObserver = null;
				this._tween = gsapWithCSS.to(target, {
					...preset.to,
					duration: parseFloat(this.dataset.duration ?? "1.0"),
					delay: parseFloat(this.dataset.delay ?? "0"),
					ease: this.dataset.ease ?? "power3.out",
					onComplete: () => {
						this._played = true;
					}
				});
			}, { rootMargin: "0px 0px -5% 0px" });
			this._animObserver.observe(target);
			return;
		}
		replaceHyphens(target);
		this.splitText = SplitText.create(target, {
			type,
			aria: false,
			autoSplit: true,
			linesClass: "split-line",
			wordsClass: "split-word",
			charsClass: "split-char"
		});
		const els = this.splitText[type];
		gsapWithCSS.set(els, {
			...preset.from,
			visibility: "visible"
		});
		gsapWithCSS.set(target, {
			opacity: 1,
			visibility: "visible"
		});
		this._animObserver = new IntersectionObserver((entries) => {
			if (!entries[0].isIntersecting) return;
			this._animObserver.disconnect();
			this._animObserver = null;
			this._tween = gsapWithCSS.fromTo(els, preset.from, {
				...preset.to,
				duration: parseFloat(this.dataset.duration ?? "1.0"),
				delay: parseFloat(this.dataset.delay ?? "0"),
				stagger: { amount: parseFloat(this.dataset.stagger ?? "0") },
				ease: this.dataset.ease ?? "power3.out",
				onComplete: () => {
					this._played = true;
					this.splitText.revert();
					normalizeSpaces(target);
				}
			});
		}, { rootMargin: "0px 0px -5% 0px" });
		this._animObserver.observe(els[0] ?? target);
	}
	disconnectedCallback() {
		this._viewObserver?.disconnect();
		this._animObserver?.disconnect();
		this._tween?.kill();
		if (this.splitText) {
			const target = this.querySelector(":scope > :first-child");
			this.splitText.revert();
			if (target) normalizeSpaces(target);
		}
	}
};
customElements.define("in-view-text", InViewText);
//#endregion
